import { ReactElement, ReactNode, useState } from 'react';
import { UINavPart } from './models';
import { UINavContext } from './context';

type Props = {
    readonly children?: ReactNode;
};
export function UINavProvider(props: Props): ReactElement {
    const { children } = props;

    const [parts, setParts] = useState<UINavPart[]>([]);

    return (
        <UINavContext.Provider
            value={{
                parts,
                setParts
            }}
        >
            {children}
        </UINavContext.Provider>
    );
}
